/**
 * App user roles.
 * Developer mirrors SA permissions but is hidden from people pickers
 * (task assignees etc.) — it only shows up on the App Users page.
 * Member mirrors Partner permissions but has no access to the Finance section.
 */
export const ROLES = {
  SA: 'SA',
  DEVELOPER: 'Developer',
  PARTNER: 'Partner',
  MEMBER: 'Member'
};

const ADMIN_ROLES = [ROLES.SA, ROLES.DEVELOPER];

export const isAdminRole = (role) => ADMIN_ROLES.includes(role);

export const isHiddenRole = (role) => role === ROLES.DEVELOPER;

const PARTNER_ROLES = [ROLES.PARTNER, ROLES.MEMBER];

export const isPartnerRole = (role) => PARTNER_ROLES.includes(role);

export const canAccessFinance = (role) => role !== ROLES.MEMBER;
